import styled from "styled-components"

const Link = styled.span`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  font-weight: bold;
  font-size: 0.85rem;
`

export { Link }
